module.exports = __webpack_public_path__ + "static/media/ehealth-bg1-16-9.548b66fa.jpg";